import { Loader } from '@googlemaps/js-api-loader';
// @ts-ignore
const TempStars = window.TempStars || {}

const loader = new Loader({
    // Guard Config — Craco-only / early import can run before F7 Config is hydrated.
    apiKey: TempStars.Config?.env?.name === 'production'
        ? 'AIzaSyDTgyx-QvToWLD14DXXuL9VCJM4CNZQda8'
        : 'AIzaSyB1eG57t-eolKSOUPgtZZowNa0_qEO8whs',
    version: 'weekly',
    libraries: ['places','maps','marker'], // Load the required libraries
});

loader.load().then((google) => {
    TempStars.Autocomplete.initGoogle(google)
}).catch((e) => {
    console.error('Error loading Google Maps API:', e);
});

export const Autocomplete = {
    init: (restrictions: any, listener: (e: any) => any) => {
        TempStars.Autocomplete.init(restrictions, listener)
    },

    removeListener: () => {
        return TempStars.Autocomplete.removeListener()
    }
}